import { parseQuery } from './parse-query';

/**
 * Allow an un-processed query string to be passed in.
 * This is mostly for NextJS, which makes parsing nested
 * query strings a pain.
 */
export function preprocessJsonApiQuery(input: unknown): unknown {
    if (typeof input === 'string') {
        const pieces = input.split('?');

        const result =
            pieces.length > 1 ? parseQuery(pieces[1]) : parseQuery(pieces[0]);

        return result;
    }

    return input;
}

export function preprocessSort(input: unknown): unknown {
    if (typeof input !== 'string') {
        return input;
    }

    return input.split(',').map((f) => {
        const field = f.replace(/^-/, '');
        const direction = f.startsWith('-') ? 'DESC' : 'ASC';

        return { field, direction };
    });
}
